/**
 * Modern Scroll Implementation
 * Replaces jQuery mousewheel plugin with native wheel events and CSS custom scrollbars
 */
(function() {
    'use strict';

    // スクロールエリアの初期化
    function initScrollArea(element) {
        // 既に初期化済みの場合はスキップ
        if (element.classList.contains('modern-scroll-initialized')) {
            return;
        }

        element.classList.add('modern-scroll-initialized', 'custom-scrollbar');

        // タッチデバイスでのスクロール最適化
        if ('ontouchstart' in window) {
            element.style.webkitOverflowScrolling = 'touch';
        }

        // passive event listener でパフォーマンス向上
        element.addEventListener('wheel', function(e) {
            // デフォルトのスクロール動作を許可（preventDefaultしない）
            // この要素が実際にスクロール可能かチェック
            const canScrollVertically = element.scrollHeight > element.clientHeight;
            const canScrollHorizontally = element.scrollWidth > element.clientWidth;

            if (!canScrollVertically && !canScrollHorizontally) {
                return;
            }

            // スクロール方向を判定
            const deltaY = e.deltaY;
            const deltaX = e.deltaX;

            // 縦スクロール可能な場合
            if (canScrollVertically && Math.abs(deltaY) > Math.abs(deltaX)) {
                const currentScrollTop = element.scrollTop;
                const maxScrollTop = element.scrollHeight - element.clientHeight;

                // 上下端でのスクロールを制限（ページスクロールを防ぐ）
                if ((deltaY < 0 && currentScrollTop <= 0) ||
                    (deltaY > 0 && currentScrollTop >= maxScrollTop)) {
                    e.preventDefault();
                }
            }

            // 横スクロール可能な場合
            if (canScrollHorizontally && Math.abs(deltaX) > Math.abs(deltaY)) {
                const currentScrollLeft = element.scrollLeft;
                const maxScrollLeft = element.scrollWidth - element.clientWidth;

                // 左右端でのスクロールを制限
                if ((deltaX < 0 && currentScrollLeft <= 0) ||
                    (deltaX > 0 && currentScrollLeft >= maxScrollLeft)) {
                    e.preventDefault();
                }
            }
        }, { passive: false }); // preventDefaultが必要な場合があるのでpassive: false
    }

    // DOM読み込み完了後に初期化
    function initializeScrollAreas() {
        const scrollAreas = document.querySelectorAll('.scrArea');
        scrollAreas.forEach(initScrollArea);
    }

    // DOM読み込み完了を待つ
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeScrollAreas);
    } else {
        initializeScrollAreas();
    }

    // 動的に追加される要素にも対応
    if (window.jQuery) {
        jQuery(document).ready(function($) {
            // jScrollPane の呼び出しを置き換え
            $.fn.jScrollPane = function(options) {
                return this.each(function() {
                    initScrollArea(this);
                });
            };
        });
    }
})();
